import React from 'react'
import Select from 'react-select';
import { makeDarkSelectStyles } from '../selectStyles';

export default function SelectStatus({ callback, value, width ,name="status" }) {

    const customStyles = makeDarkSelectStyles({ width: width || '200px' });

    
    var options = [
        {
            label: "Active",
            value: true
        },
        {
            label : "Deactive",
            value : false
        },
    ]

    const handleSelect = (e) => {
        var value = e.value;
        callback(value, name)

    }

    return (
        <>
            <div className="filter-select">
                <Select options={options}
                    styles={customStyles}
                    onChange={handleSelect}
                    placeholder="Status"
                    value={options && options.filter(obj => obj.value === value)}


                />
            </div>
            
        </>
    )
}
